import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { IconTypes, NavigationSourceService } from '@shared/v2';

@Component({
  selector: 'sd-checkout-header',
  imports: [SdvorIconComponent],
  templateUrl: './checkout-header.component.html',
  styleUrls: ['./checkout-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutHeaderComponent {
  private deviceService = inject(DeviceService);
  private navigationSourceService = inject(NavigationSourceService);

  protected readonly iconTypes = IconTypes;
  protected readonly isMobileSmDown = toSignal(this.deviceService.isMobileSmDown$, { initialValue: false });

  onNavigationBack(): void {
    this.navigationSourceService.goBack();
  }
}
